import { Shield } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';
import pt from '../../locales/pt';

/**
 * Molde educativo — só informação, sem input (ex.: «Entender» do fundo de emergência).
 *
 * Sem master `.pen` dedicado (o wizard do fundo de emergência não tem frames no
 * documento). Construído com a linguagem já estabelecida: medalhão + bloco
 * `ds/message--sage` para o corpo + círculos numerados de `ds/wizard/step--*`.
 */
export function WizardEduBlock({
  icon: Icon = Shield,
  badgeLabel,
  body,
  points = [],
  className,
}) {
  const copy = pt.wizard.common;

  return (
    <div className={cn('flex flex-col gap-space-4', className)}>
      <div className="flex justify-center">
        <div className="grid size-16 place-items-center rounded-ds-xl border border-sage-border bg-sage-tint">
          <Icon className="size-8 text-sage-on-tint" weight="regular" aria-hidden />
        </div>
      </div>

      {body ? (
        <div
          data-ds-id="ds/message--sage"
          className="flex flex-col gap-space-2 rounded-ds-lg border border-sage-border bg-sage-tint p-space-4"
        >
          <div className="text-type-section font-bold uppercase tracking-[0.06em] text-sage-on-tint">
            {badgeLabel || copy.howItWorks}
          </div>
          <p className="m-0 text-type-body-sm leading-[1.5] text-sage-on-tint">{body}</p>
        </div>
      ) : null}

      {points.length > 0 ? (
        <ul className="m-0 flex list-none flex-col gap-space-2-5 p-0">
          {points.map((point, index) => (
            <li key={index} className="flex items-start gap-space-3">
              <span
                className="grid size-6 shrink-0 place-items-center rounded-ds-full bg-sage-tint text-type-label font-bold tabular-nums text-sage-on-tint"
                aria-hidden
              >
                {index + 1}
              </span>
              <p className="m-0 text-type-body-sm leading-[1.5] text-muted-foreground">{point}</p>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}

export default WizardEduBlock;
